import type { WALLET_NAME } from "@/constants/wallet"
import { getWalletLogo } from "@/constants/wallet"
import type { SelectOption } from "@/design-system/Select"
import {
  useConnectedWallet,
  useInstalledWallets,
} from "@/providers/Wallet/selectors"

export type WalletOption = SelectOption<WALLET_NAME>

export const useWalletOptions = (): WalletOption[] => {
  const installedWallets = useInstalledWallets()
  const connectedWallet = useConnectedWallet()
  const walletOptions = installedWallets.map(walletName => ({
    label: walletName,
    value: walletName,
    Logo: getWalletLogo(walletName),
  }))
  const activeWalletOption = walletOptions.find(
    option => option.value === connectedWallet,
  )
  const sortedWalletOptions = activeWalletOption
    ? [
        activeWalletOption,
        ...walletOptions.filter(option => option.value !== connectedWallet),
      ]
    : walletOptions
  return sortedWalletOptions
}
